import Accordion from "../../components/Accordion";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

export default function FAQPage() {

  return (
    <div>
      <Header/>
      <main className='wrapper top-space bottom-space'>
        <h1 className='text-center text-title2 lg:text-display1'>자주 하는 질문</h1>

        <div className='flex justify-end mt-[60px]'>
          <button 
            className='px-[25px] py-[15px] font-semibold text-label1 lg:text-heading3 text-white bg-primary-400'
            onClick={() => window.open('https://static.module-link.com/linkcall/pdf/%EB%A7%81%EC%BD%9C+%EC%82%AC%EC%9A%A9%EC%84%A4%EB%AA%85%EC%84%9C+(%EC%9D%B8%EC%87%84%EC%9A%A9).pdf')}
          >
            링콜 사용설명서
            </button>
        </div>

        <div className='mt-[120px]'>
          <Accordion title='Q. 제품의 전원 스위치는 어디에 있나요?'>
            <div className='text-heading2 font-semibold'>A. 링콜에는 별도의 전원 스위치가 없습니다.</div>
            <ul>
              <li>제품이 부착된 전동차가 움직이면 자동으로 켜지고, 5분 이상 움직임이 없으면 자동으로 꺼지는 스마트 전원 관리 시스템이 적용되어 있습니다.</li>
              <li>따라서, 매번 전원을 켜거나 끌 필요 없이, 전동차를 평소처럼 사용하시면 자동으로 작동합니다.</li>
            </ul>
          </Accordion>

          <Accordion title='Q. 링콜의 이용료가 있나요?'>
            <div className='text-heading2 font-semibold'>A. 아니요. 제품을 구매하신 경우, 링콜의 기본 기능은 모두 무료로 이용하실 수 있습니다.</div>
            <ul>
              <li>실시간 사고 감지 및 자동 구조 요청 기능은 기본 서비스로 제공됩니다.</li>
              <li>단, 앱을 통해 별도로 신청하는 부가 서비스나 제품 구매 과정에서 선택하는 추가 옵션에는 비용이 발생할 수 있습니다.</li>
            </ul>
          </Accordion>

          <Accordion title='Q. 제품이 작동하지 않아요. 30초 이상 기다려도 파란색 LED 불빛이 점멸되지 않아요.'>
            <div className='text-heading2 font-semibold'>A. 30초 이상 기다려도 파란색 LED가 점멸되지 않는 경우, 아래 항목을 순서대로 확인해 주세요.</div>
            <ul>
              <li>AA 건전지가 올바른 극성(＋ / －)으로 삽입되었는지 확인하세요.<br/>(※ 극성이 잘못되면 전원이 공급되지 않습니다.)</li>
              <li>건전지가 방전되었을 수 있습니다. 새 건전지로 교체해 보세요.</li>
              <li>건전지 커버가 완전히 닫혀 있는지 확인하세요.<br/>(※ 느슨하거나 제대로 닫히지 않으면 전원이 연결되지 않습니다.)</li>
              <li>제품을 살짝 흔들어 초절전 상태를 해제해 보세요.</li>
              <li>제품이 등록된 스마트폰이 가까이에 있는지 확인하세요.<br/>(※ 블루투스 연결이 끊어지면 제품 전원이 자동으로 꺼집니다.)</li>
              <li>앱에서 블루투스가 활성화되어 있는지 확인하세요.</li>
              <li>위 방법으로도 해결되지 않는 경우, 고객센터로 문의해 주세요.</li>
            </ul>
          </Accordion>

          <Accordion title='Q. 앱에서 제품이 검색되지 않아요.'>
            <div className='text-heading2 font-semibold'>A. 링콜 제품이 앱에 표시되지 않을 경우, 다음 항목을 순서대로 확인해 주세요.</div>
            <ul>
              <li>스마트폰의 블루투스 기능이 켜져 있는지 확인하세요.</li>
              <li>제품이 정상 작동 중인지 확인하세요.<br/>(※ 건전지가 올바르게 삽입되어 있고, 방전되지 않았는지 확인)</li>
              <li>다른 블루투스 기기(이어폰, 스마트워치 등)와의 간섭이 있는지 점검해 보세요.<br/>(※ 간섭으로 인해 연결이 지연되거나 실패할 수 있습니다.)</li>
              <li>앱을 재실행하거나 스마트폰을 재부팅한 후 다시 시도해 보세요.</li>
              <li>제품 등록이 이미 완료된 경우, 동일한 스마트폰에서만 연결 가능합니다.<br/>(※ 등록된 제품은 중복 연결되지 않습니다.)</li>
            </ul>
          </Accordion>

          <Accordion title='Q. 사고를 100% 정확하게 감지하나요?'>
            <div className='text-heading2 font-semibold'>A. 아니요. 모든 사고를 완벽하게 감지하는 것은 어렵습니다.</div>
            <ul>
              <li>링콜은 다양한 사고 감지 테스트와 AI 기반 분석 기능을 통해 대부분의 사고를 실시간으로 자동 감지하고, GPS 위치와 함께 구조 요청을 전송합니다.</li>
              <li>그러나 사고의 유형, 형태, 환경 조건에 따라 일부 상황은 정확하게 감지되지 않을 수 있습니다.</li>
              <li>이 경우, 제품의 버튼을 2초간 길게 눌러 수동으로 구조 요청할 수 있습니다.<br/>(※ 사용설명서의 “수동 구조 요청” 항목 참고)</li>
            </ul>
          </Accordion>

          <Accordion title='Q. 사고가 발생했는데 자동으로 사고 감지 신호(빨간색 LED 점멸)가 발생하지 않습니다.'>
            <div className='text-heading2 font-semibold'>A. 다음과 같은 원인으로 인해 자동 사고 감지 기능이 작동하지 않을 수 있습니다.</div>
            <ol>
              <li>
                  스마트폰 환경 문제
                  <ul className='!mt-0'>
                    <li>(Android) 스마트폰이 꺼져 있거나, 링콜 앱이 백그라운드에서 종료된 경우</li>
                    <li>(iPhone) 스마트폰이 꺼져 있거나, 앱이 실행 중이지 않은 경우</li>
                  </ul>
                </li>
                <li className='mt-[10px]'>
                  제품과 스마트폰 간 연결 끊김
                  <ul className='!mt-0'>
                    <li>블루투스 무선 통신이 해제된 상태</li>
                    <li>스마트폰의 위치 정보(GPS) 또는 모바일 데이터 사용이 꺼진 상태</li>
                  </ul>
                </li>
                <li className='mt-[10px]'>
                  비학습 사고 패턴 또는 환경 조건 외 상황
                  <ul className='!mt-0'>
                    <li>아직 학습되지 않은 새로운 사고 유형</li>
                    <li>사용자 조건 또는 특정 주행 환경에서 감지 알고리즘이 인식하지 못하는 경우</li>
                  </ul>
                </li>
              </ol>

              <div className='mt-[35px]'>
                ※ 주의사항
                <ul>
                  <li>링콜은 다양한 사고 유형을 자동 감지하도록 설계되었지만, 일부 상황에서는 감지가 누락되거나 오탐지(오경보)가 발생할 수 있습니다.</li>
                  <li>이 경우, 제품의 버튼을 2초간 길게 눌러 수동으로 구조 요청해 주세요.</li>
                </ul>

                <br/><br/>
                이와 같은 데이터는 AI 학습에 활용되어 감지 정확도를 향상시키는 데 도움이 됩니다. 
              </div>
          </Accordion>

          <Accordion title='Q. 건전지는 얼마나 자주 교체해야 하나요?'>
            <div className='text-heading2 font-semibold'>A. 하루 2시간 사용 기준으로 약 6개월간 사용할 수 있습니다.</div>
            <ul>
              <li>단, 사용 환경, 주행 습관, 건전지 브랜드에 따라 실제 사용 기간은 달라질 수 있습니다.</li>
              <li>앱에서 건전지 교체 알림이 발생하면 즉시 교체해 주세요.</li>
            </ul>
          </Accordion>

          <Accordion title={`Q. 실수로 버튼을 길게 눌러 응급구조 신호가 발생했어요.\n응급구조 신호가 발생했지만, 다치지 않아서 119 응급구조대의 출동이 필요 없을 것 같아요.`}>
            <div className='text-heading2 font-semibold'>A. 당황하지 마세요. 빨간색 LED가 점멸되는 동안, 버튼을 짧게 눌러 구조 요청을 취소할 수 있습니다.</div>
            <ul>
              <li>구조 요청은 일정 시간 내에 버튼을 짧게 누르면 즉시 취소됩니다.</li>
              <li>취소 시, 앱에서 구조 요청이 해제되었다는 알림이 표시됩니다.</li>
              <li>만약 취소 시간이 경과한 경우, 구조 요청이 119로 자동 전송될 수 있으니 빠르게 조치해 주세요.</li>
            </ul>
          </Accordion>

          <Accordion title='Q. 제품이 비(또는 눈)를 맞았어요.'>
            <div className='text-heading2 font-semibold'>A. 걱정하지 않으셔도 됩니다. 링콜은 IP56 등급의 생활 방수 기능을 갖추고 있어, 일시적인 비나 눈에도 안전하게 작동하도록 설계되어 있습니다.</div>

            <br/>
            단, 더 안전한 사용을 위해 다음과 같은 조치를 권장합니다.
            <ul>
              <li>제품에서 건전지를 분리하세요.</li>
              <li>겉면의 물기를 마른 천으로 닦고, 내부까지 충분히 건조시켜 주세요.</li>
              <li>완전히 건조된 후에 건전지를 다시 삽입하고 사용해 주세요. </li>
            </ul>
          </Accordion>

          <Accordion title='Q. 제품을 여러 대의 스마트폰과 함께 사용할 수 있나요?'>
            <div className='text-heading2 font-semibold'>A. 아니요. 링콜은 1대의 스마트폰과 1대의 제품이 1:1로만 연결됩니다.</div>
            <ul>
              <li>이는 응급상황 발생 시, 등록된 사용자 정보에 기반해 정확한 신원 확인과 빠른 구조 대응을 가능하게 하기 위한 구조입니다.</li>
              <li>따라서 여러 기기에서 동시에 사용할 수 없으며, 제품 등록은 1개의 스마트폰에서만 가능합니다.</li>
            </ul>
          </Accordion>

          <Accordion title='Q. 해외에서도 사용할 수 있나요?'>
            <div className='text-heading2 font-semibold'>A. 아니요. 링콜은 대한민국 내에서만 사용이 가능합니다.</div>
            <ul>
              <li>본 제품은 국내 통신망 및 119 응급구조 시스템과 연동되도록 설계되어 있어, 해외에서는 긴급 구조 요청 서비스가 제공되지 않습니다.</li>
              <li>해외에서 사용할 경우, 위치 정보 전송이나 구조 대응이 이루어지지 않습니다. </li>
            </ul>
          </Accordion>

          <Accordion title='Q. 국내에서 서비스되는 지역에 한계가 있나요?'>
            <div className='text-heading2 font-semibold'>A. 국내에서는 대부분의 지역에서 정상적으로 사용할 수 있습니다.</div>
            <ul>
              <li>링콜 제품은 블루투스, GPS, 모바일 데이터(4G, LTE, 5G) 통신을 기반으로 작동합니다.</li>
              <li>따라서 이동통신망이 연결되는 지역이라면 서비스 이용이 가능합니다.</li>
              <li>단, 통신 음영 지역(지하, 산간 오지 등)에서는 일부 기능이 제한될 수 있습니다.</li>
            </ul>
          </Accordion>

          <Accordion title='Q. 응급구조를 요청하면 링콜이 직접 현장에 출동하나요?'>
            <div className='text-heading2 font-semibold'>A. 아니요. 링콜은 구조대가 아닙니다.</div>
            <ul>
              <li>링콜은 응급상황 발생 시, 119 응급구조대에 자동 또는 수동으로 출동 요청을 전송하는 장치입니다.</li>
              <li>사용자가 전화 통화나 상황 설명이 어려운 상황에서도, 위치정보와 함께 구조 요청을 대신 전달해 신속한 응급구조대 출동을 도와줍니다.</li>
            </ul>
          </Accordion>

          <Accordion title='Q. 제품을 타인에게 양도하거나 대여할 수 있나요?'>
            <div className='text-heading2 font-semibold'>A. 아니요. 링콜은 최초 등록한 사용자만 사용할 수 있으며, 타인에게 양도하거나 대여할 수 없습니다.</div>
            <ul>
              <li>이는 사용자 정보와 긴급 구조 요청이 연결되어 있기 때문에, 정확한 신원확인과 응급 대응을 위해 반드시 1인 1기기 원칙을 따릅니다.</li>
              <li>
                단, 스마트폰 기기를 변경하는 경우에는 예외적으로 다음 절차를 통해 등록을 이전할 수 있습니다.
                <ol className='!mt-0'>
                  <li>기존 스마트폰에서 앱의 ‘제품 관리’ 메뉴에서 등록 제품 삭제</li>
                  <li>새로운 스마트폰에 링콜 앱 설치 후 다시 제품 등록</li>
                </ol>
              </li>
            </ul>
          </Accordion>

          <hr/>
        </div>
      </main>
      <Footer/>
    </div>
  )
}